import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ModalService } from '@common/services/ModalService/ModalService';

@Component({
  templateUrl: './forgottenPasswordView.component.html',
  styleUrls: ['./forgottenPasswordView.component.scss'],
})
export class ForgottenPasswordViewComponent implements OnInit {
  forgottenPasswordForm: FormGroup;
  submitted = false;

  constructor(
    public authService: AuthService,
    public modalService: ModalService,
  ) {}

  ngOnInit() {
    this.forgottenPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  onFormSubmit(e) {
    e.preventDefault();

    this.authService.requestPasswordReset(this.forgottenPasswordForm.get('email').value)
      .subscribe(
        (res) => {
          this.modalService.openModal({ type: 'passwordResetRequestSent' });
        },
        (err) => {
          this.modalService.openModal({ type: 'errorOccurred' });
          this.submitted = false;
        },
      );

    this.submitted = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/views/forgottenPasswordView/forgottenPasswordView.component.ts